export default __webpack_public_path__ + "static/media/opensea.d89d998d.png";